import React from "react";

const ConfirmResetModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      <section className="modal-body">
        <div className="modal-head">
          {props.Data.candidate.revealIdentity ? (
            <React.Fragment>
              {props.Data.candidate.imageThumbnailUrl === null ? (
                <span
                  className="avatar-placeholder"
                  style={{
                    color: props.Data.candidate.textColorCode,
                    backgroundColor: props.Data.candidate.backgroundColorCode,
                  }}
                >
                  <p>
                    {props.Data.candidate.firstName.slice(0, 1).toUpperCase() +
                      props.Data.candidate.lastName.slice(0, 1).toUpperCase()}
                  </p>
                </span>
              ) : (
                <span className="avatar-placeholder">
                  <img
                    alt="candidate"
                    src={props.Data.candidate.imageThumbnailUrl}
                    className="candidate-avatar"
                  />
                </span>
              )}
            </React.Fragment>
          ) : (
            <span className="incognito">
              <img src={props.AnonymousIcon} />
            </span>
          )}
          <span className="info">
            {props.Data.candidate.revealIdentity ? (
              <p className="candidate-name">
                {props.Data.candidate.firstName +
                  " " +
                  props.Data.candidate.lastName}
              </p>
            ) : (
              <p className="candidate-name">{translateText("anonymous")}</p>
            )}
            <p className="candidate-position">
              {" "}
              {props.Data.candidate.currentPositionTitle}
            </p>
          </span>
          <i className="feather-x" onClick={() => props.Close()}></i>
        </div>
        <h1 className="modal-message">
          {translateText("confirm_reset_application_text")}
        </h1>
        <div className="actions">
          <button onClick={() => props.Close()}>Discard</button>
          <button
            className="reject-btn reset-btn"
            onClick={() => props.AcceptReset()}
          >
            {translateText("jpa_actions_reset_application")}
          </button>
        </div>
      </section>
    </div>
  );
};

export default ConfirmResetModal;
